import citys from "@/assets/js/cityData.js";
import { getUrlParams } from "@/assets/js/util.js";
export function saveStorage(key, val) {
  let str = JSON.stringify(val);
  sessionStorage.setItem(key, str);
}

export function loadStorage(key) {
  var str = sessionStorage.getItem(key) ? sessionStorage.getItem(key) : "";
  return str ? JSON.parse(str) : "";
}

export function saveLocalStorage(key, val) {
  let str = JSON.stringify(val);
  localStorage.setItem(key, str);
}

export function loadLocalStorage(key) {
  var str = localStorage.getItem(key) ? localStorage.getItem(key) : "";
  return str ? JSON.parse(str) : "";
}

export function getCurrentSeconds() {
  return Math.floor(new Date().getTime() / 1000);
}

export function loadCurrentCity() {
  // 如果url上带了城市名则优先加载url上的城市名
  let name = getUrlParams()["city_name"]
    ? decodeURIComponent(getUrlParams()["city_name"])
    : "";
  if (name) {
    let city_id = null;
    for (let key in citys) {
      for (let i = 0; i < citys[key].length; i++) {
        if (citys[key][i].name === name) {
          city_id = citys[key][i]["id"];
        }
      }
    }
    var info = {
      city_name: name,
      date: getCurrentSeconds(),
      city_id
    };
    if (city_id) {
      localStorage.setItem("myLocationInfo", JSON.stringify(info));
      return info;
    }
  }
  var info = cityInfo
    ? {
      city_id: cityInfo.city_id,
      city_name: cityInfo.name,
      area_code: cityInfo.standard_code
    }
    : { city_id: 200, city_name: "深圳", area_code: "440300" };
  var localInfo = localStorage.getItem("myLocationInfo") ? JSON.parse(localStorage.getItem("myLocationInfo")) : ""
  var myLocationInfo = localInfo
    ? localInfo
    : "";
  if (
    myLocationInfo &&
    myLocationInfo.date &&
    getCurrentSeconds() - myLocationInfo.date < 86400
  ) {
    // 86400
    info = myLocationInfo;
  } else {
    localStorage.removeItem("myLocationInfo");
  }

  var local = {
    city_id: info.city_id,
    city_name: info.city_name,
    date: getCurrentSeconds(),
    lon_lat: info.lon_lat,
    area_code: info.area_code
  };

  if (!localStorage.getItem("myLocationInfo") && local.lon_lat) {
    localStorage.setItem("myLocationInfo", JSON.stringify(local));
  }
  return local;
}

export function getCurrentCity() {

  var info = cityInfo
    ? {
      city_id: cityInfo.city_id,
      city_name: cityInfo.name,
      area_code: cityInfo.standard_code
    }
    : { city_id: 200, city_name: "深圳", area_code: "440300" };
  var myLocationInfo = localStorage.getItem("myLocationInfo")
    ? JSON.parse(localStorage.getItem("myLocationInfo"))
    : "";
  if (myLocationInfo) {
    info = myLocationInfo;
  }
  var local = {
    city_id: info.city_id,
    city_name: info.city_name,
    date: getCurrentSeconds(),
    lon_lat: info.lon_lat
  };
  return local;
}

export function saveCurCity(city) {
  city.date = getCurrentSeconds();
  if (
    localStorage.getItem("myLocationInfo") &&
    JSON.parse(localStorage.getItem("myLocationInfo")).lon_lat
  ) {
    city.lon_lat = JSON.parse(localStorage.getItem("myLocationInfo")).lon_lat;
  }
  localStorage.setItem("myLocationInfo", JSON.stringify(city));
}
/* 读取当前套餐 */
export function loadCurPac() {
  var item = localStorage.getItem("curPac");
  if (item) {
    if (JSON.parse(item)) {
      return JSON.parse(item);
    }
    return {};
  }
  // return item ? JSON.parse(item) : {};
}

export function saveCurPac(item) {
  if (item) {
    localStorage.setItem("curPac", JSON.stringify(item));
    return item;
  }
}

/* 读取当前机构 */
export function loadCurOrg() {
  var item = localStorage.getItem("curOrg");
  // console.log('读取当前机构', item)
  return item ? JSON.parse(item) : {};
}

export function saveCurOrg(item) {
  if (item && window.localStorage) {
    // console.log('存储当前机构', item)
    localStorage.setItem("curOrg", JSON.stringify(item));
    return item;
  }
}

export function loadInvoice() {
  return localStorage.getItem("invoiceType") || "";
}
export function saveInvoice(str) {
  localStorage.setItem("invoiceType", str);
  return str;
}

export function loadCurOrder() {
  var item = localStorage.getItem("curOrder");
  return item ? JSON.parse(item) : {};
}
export function saveCurOrder(item) {
  localStorage.setItem("curOrder", JSON.stringify(item));
  return item;
}

// 变啦体检卡
export function loadCurCard() {
  var item = localStorage.getItem("curCard");
  if (item) {
    return JSON.parse(item);
  }
}
export function saveCurCard(item) {
  if (item) {
    localStorage.setItem("curCard", JSON.stringify(item));
    return item;
  }
}
// 套餐选择机构类型
export function loadCurOrderType() {
  var type = localStorage.getItem("curOrderType");
  return parseInt(type) || 0;
}
export function saveCurOrderType(type) {
  localStorage.setItem("curOrderType", type);
  return type;
}
